/** "1 room" / "2 rooms". Pass `plural` for irregular nouns ("child" -> "children"). */
export function pluralize(
    count: number,
    singular: string,
    plural = `${singular}s`,
): string {
    return `${count} ${count === 1 ? singular : plural}`;
}
